import Vue from 'vue'
import App from './App'
import router from './router'
import MintUI from 'mint-ui'
import Element from 'element-ui'
import echarts from 'echarts' // 引入echarts
import storage from 'good-storage' // 引入good-storage 用于缓存
import 'signalr' // 引入signalr 用于实时更新
import "babel-polyfill";

Vue.config.productionTip = false
Vue.prototype.$echarts = echarts // 全局注册echarts
Vue.prototype.$storage = storage
Vue.use(MintUI)
Vue.use(Element)

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js